import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import { capitalize } from 'lodash'
import Dropdown from './dropdown'
import css from './menu.css'

export default class Menu extends Component {
    state = {
        startingMousePosition: 0,
        backgroundPosition: 0,
    }
    render() {
        const { items } = this.props
        const { backgroundPosition } = this.state

        return (
            <div className={css.menuContainer}>
                <ul
                    className={css.menuList}
                    style={{ backgroundPositionX: `${backgroundPosition}px` }}
                    onMouseEnter={e => {
                        this.setState({
                            startingMousePosition: e.pageX,
                        })
                    }}
                >
                    {items.map((item, i) => (
                        <li
                            className={css.menuItem}
                            key={i}
                            onMouseMove={e => {
                                const { startingMousePosition } = this.state

                                this.setState({
                                    backgroundPosition: e.pageX - startingMousePosition,
                                })
                            }}
                        >
                            <a className={css.menuLink} href={`/${item}`}>
                                {capitalize(item)}
                            </a>
                        </li>
                    ))}
                    <li className={`${css.menuItem} ${css.ellipsis}`}>
                        <a
                            className={`${css.menuLink} ellipsis-link`}
                            href="#"
                            onClick={e => {
                                e.preventDefault()
                            }}
                        >
                            <i className={css.ellipsisIcon} />
                        </a>
                        <Dropdown css={css} />
                    </li>
                </ul>
            </div>
        )
    }
}
